import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { pluck } from 'rxjs/operators';
import { Notification } from 'src/app/shared/models';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  constructor(private readonly http: HttpClient) {}

  public getNotifications(userId: number): Observable<Notification[]> {
    if (userId) {
      const url = `/api/webapp-partnerhub-admin/users/${userId}/notifications`;

      return this.http.get<Notification[]>(url).pipe(pluck('responseData'));
    }
    return of([]);
  }

  public markNotificationsAsRead(userId: number): Observable<any> {
    const url = `/api/webapp-partnerhub-admin/users/${userId}/notifications`;

    return this.http.post<any>(url, {});
  }
}
